export const INTEGRATIONS = {
  components: 1,
  apis: 2,
};

export const PAGE_STATUS = {
  draft: 1,
  published: 2,
  unpublished: 3,
};
